<template>
  <fieldset>
    <legend
      :class="libelleStyle + ' truncate mb-2 flex items-center gap-x-1'"
      :style="
            inherits != undefined && inherits != null && inherits
              ? 'color: inherit; font-size: inherit; font-weight: inherit;'
              : ''
          "
    >
      {{ libelle }} <span v-if="required" class="text-pink-600">*</span>
      <div
        v-if="libelleIcon"
        @click.stop="$emit('clickIcon')"
        class="cursor-pointer"
      >
        <icon :name="libelleIcon" :class="libelleIconStyle" />
      </div>
    </legend>
    <div
      v-if="answerArray.length > 1"
      class="p-1 w-full rounded-jauge border justify-start items-start inline-flex"
    >
      <AnswerItem
        v-for="(i, index) in answerArray"
        :is-unevaluated="i === unevaluatedIndex"
        :reduced="reduced"
        :key="i"
        :answer="i"
        :selected="i === selected_mut"
        @select="select(i, index)"
        @unselect="select(undefined, index)"
        :disabled="disabled"
      ></AnswerItem>
    </div>
  </fieldset>
</template>
<script>
import AnswerItem from './AnswerItem.vue';
import Icon from '../../Icon.vue';

const unevaluatedCriteria = [
  "Non observable",
  "Non observable 🫣",
  "Non concerné",
  "Non effectué (NE)",
  "Non concerné ✖️",
];

export default {
  components: { Icon, AnswerItem },
  props: {
    selected: {
      required: false,
      default: undefined,
    },
    criteria: Array,
    disabled: Boolean,
    reduced: {
      type: Boolean,
      required: false,
      default: false,
    },
    libelle: {
      type: String,
      required: false,
      default: undefined,
    },
    libelleStyle: {
      type: String,
      required: false,
      default: undefined,
    },
    libelleIcon: {
      type: String,
      required: false,
      default: undefined,
    },
    libelleIconStyle: {
      type: String,
      required: false,
      default: 'text-pink-600 h-2.5',
    },
    inherits: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selected_mut: undefined,
    };
  },
  mounted() {
    this.updateSelectedMutable(this.selected);
  },
  methods: {
    select(answer, index) {
      if (answer === undefined) {
        this.$emit('select', answer);
      } else {
        this.$emit('select', this.mapCriterionIdxToAnswerIdx(index));
      }
    },
    getSelectedCriteriaIdx(criterion) {
      return this.criteria.map((v) => v.value).indexOf(criterion);
    },
    mapCriterionIdxToAnswerIdx(idx) {
      return (this.answerCount - idx - 1) % this.answerCount;
    },
    updateSelectedMutable(value) {
      if (value) {
        let criterionIdx = this.getSelectedCriteriaIdx(value);
        let answerIdx = this.mapCriterionIdxToAnswerIdx(criterionIdx);
        this.selected_mut = this.answerArray[answerIdx];
      } else {
        this.selected_mut = undefined;
      }
    },
  },
  computed: {
    unevaluatedIndex() {
      const criteria = this.criteria.map(v => v.value);

      const indices = unevaluatedCriteria.map(crit => {
        return criteria.indexOf(crit);
      }).filter(index => index >= 0);

      if (indices.length > 0) {
        return indices[0] + 1;
      }

      return undefined;
    },

    answerArray() {
      if (this.unevaluatedIndex === undefined) {
        if (this.answerCount === 3) {
          return [5, 3, 1];
        } else if (this.answerCount === 5) {
          return [5, 4, 3, 2, 1];
        } else if (this.answerCount === 4) {
          return [5, 4, 2, 1];
        } else if (this.answerCount === 2) {
          return [5, 1];
        } else {
          console.warn(
            `Unsupported Answer count ${this.answerCount}, defaulting to 5`
          );
          return [];
        }
      } else {
        if (this.answerCount === 3) {
          return [5, 3, this.unevaluatedIndex];
        } else if (this.answerCount === 5) {
          return [5, 4, 3, 2, this.unevaluatedIndex];
        } else if (this.answerCount === 4) {
          return [5, 4, 2, this.unevaluatedIndex];
        } else if (this.answerCount === 2) {
          return [5, this.unevaluatedIndex];
        } else {
          console.warn(
            `Unsupported Answer count ${this.answerCount}, defaulting to 5`
          );
          return [];
        }
      }

    },

    answerCount() {
      return this.criteria.length;
    },
  },
  watch: {
    selected(value) {
      this.updateSelectedMutable(value);
    },
  },
};
</script>